import styled from '@emotion/styled';

export const StyledBoxPage = styled.div`
  max-width: 1280px;
  margin: 0 auto 160px auto;
  width: 100%;
  padding: 0 12px;
`;
